import React from "react";
import "./Sustainability.css";
import img1 from "../assets/sus-img1.png";
import img2 from "../assets/sus-img2.png";
import img3 from "../assets/sus-img3.png";
import Footer from "./Footer";
import { Link } from "react-router-dom";


function Sustainability() {
    const cards = [
        {
            img: img1,
            title: "Environment",
            desc: "Minimizing our impact on the planet through operational eco-efficiency and renewable energy sources",
            route: "/environmental"
        },
        {
            img: img2,
            title: "Social",
            desc: "SCL is committed to social responsibility and the protection of human rights in both our own operations and throughout our supply chain.",
            route: "/socialsustainability"
        },
        {
            img: img3,
            title: "Governance",
            desc: "We uphold a robust framework of governance and ethical standards that reflect our dedication to transparency, honesty, and regulatory adherence across all aspects of our business.",
            route: "/Dev"
        }
    ];

    return (
        <section id="sus">
            <section className="sus-section">

                <div className="sus-light-wrapper">
                    {/* LEFT CONTENT */}
                    <div className="prod-light-text">
                        <h3>
                            Aluminium Die Casting Solutions
                            <br />
                            Engineered for Excellence
                        </h3>

                        <p>At SCL, we are a trusted partner to global automotive and industrial leaders, offering precision-engineered aluminium pressure die castings that combine lightweight design with exceptional durability and performance. With decades of expertise in Pressure (PDC), gravity (GDC) die casting, SCL delivers innovative, reliable, and sustainable solutions for mobility across segments — from heavy commercial vehicles to passenger cars.</p>
                        <p style={{ margin: "10px 0 0 0" }}>SCL machined products are engineered for dimensional accuracy, structural integrity and long service life — enabling light weighting, improved efficiency and simplified assembly for OEMs worldwide.</p>
                    </div>

                    {/* RIGHT IMAGE / PLACEHOLDER */}
                    <div className="lightweighting-image">
                        
                    </div>
                </div>

                <h2 className="sus-title">What We Offer</h2>
                <div className="sus-line"></div>

                <div className="sus-cards">
                    {cards.map((card, index) => (
                        <div className="sus-card" key={index}>
                            <div className="sus-image">
                                <img src={card.img} alt={card.title} />
                            </div>

                            <div className="sus-content">
                                <h3>{card.title}</h3>
                                <p>{card.desc}</p>

                                <Link to={card.route} className="sus-link">
                                    <span>Explore ↗</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <p style={{ textAlign: "center", margin: "50px 0 50px 0" }}>SCL is committed to transparent and responsible sustainability practices. We have achieved CDP Climate: B, CDP<br />Water: B, and an EcoVadis Sustainability Rating – Jan 2025.</p>
            </section>

            <Footer />
        </section>
    );
}

export default Sustainability;
